export class FiltroColaborador {

    filtroCodigo: string;
    filtroNome: string;
    filtroCPF: string;
    filtroMatricula: string;
    filtroAplicativo: string;
    filtroSituacao: string;
    filtroPesquisa: string;
    filtroCentroCustoSelectedItems: string[];
    filtroUnidadeSelectedItems: string[];
    filtroDepartamentoSelectedItems: string[];
    filtroProdutosSelectedItems: string[];

    constructor(
        filtroCodigo: string,
        filtroNome: string,
        filtroCPF: string,
        filtroMatricula: string,
        filtroAplicativo: string,
        filtroSituacao: string,
        filtroPesquisa: string,
        filtroCentroCustoSelectedItems: string[],
        filtroUnidadeSelectedItems: string[],
        filtroDepartamentoSelectedItems: string[],
        filtroProdutosSelectedItems: string[]
    ) {
        this.filtroCodigo = filtroCodigo;
        this.filtroNome = filtroNome;
        this.filtroCPF = filtroCPF;
        this.filtroMatricula = filtroMatricula;
        this.filtroAplicativo = filtroAplicativo;
        this.filtroSituacao = filtroSituacao;
        this.filtroPesquisa = filtroPesquisa;
        this.filtroCentroCustoSelectedItems = filtroCentroCustoSelectedItems;
        this.filtroUnidadeSelectedItems = filtroUnidadeSelectedItems;
        this.filtroDepartamentoSelectedItems = filtroDepartamentoSelectedItems;
        this.filtroProdutosSelectedItems = filtroProdutosSelectedItems;
    }
}
